"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseDocument", {
    enumerable: true,
    get: function() {
        return BaseDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const BaseDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId)
});
